import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Card, Col, Row, Button, Space, Breadcrumb, Avatar, Modal, Pagination, ConfigProvider, Typography } from "antd";
import { Flex } from "antd";
import { useState } from "react";
import { MainLayout } from "components/layouts";
import { ReactComponent as FilterIcon } from "../../../assets/icon/filterIcon.svg";
import { ReactComponent as CreateIcon } from "../../../assets/icon/createIcon.svg";

import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import { UserOutlined } from "@ant-design/icons";
import styles from "../styles/AdminCompany.module.css";
import StatusTag from "components/elements/TagCustom/StatusTag";
import AdminCompanyFilter from "./AdminCompanyFilter";

const AdminCompany = ({
  onSelectCompany = () => { },
  onAccessCompany = () => { },
  getAdminComapnyPagination = () => { },
  companyList = [],
  pagination = {},
  isLoading = false,
  handleSearch = () => { },
  userAdminListOptions = []
}) => {
  const { t, i18n } = useTranslation();
  const { Text } = Typography;
  const navigate = useNavigate();

  const [useFilter, setUseFilter] = useState(false);
  const [openListEmployee, setOpenListEmployee] = useState(false);
  const [selectedAdminList, setSelectedAdminList] = useState([]);

  useEffect(() => {
    getAdminComapnyPagination({ page: 0, size: 9 })
  }, [])

  const handleCardClick = async (companyId) => {
    try {
      await onAccessCompany(companyId);

      await onSelectCompany(companyId);

      navigate("/admin/response_company/comapany_info");
    } catch (err) {
      console.error("Error when selecting company:", err);
    }
  };

  const arrowLeft = () => {
    return <Button type="default" style={{ height: "36px" }}>
      <Flex gap={5} style={{
        placeItems: 'center'
      }}>
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M15.8334 9.99996H4.16669M4.16669 9.99996L10 15.8333M4.16669 9.99996L10 4.16663" stroke="#667085" stroke-width="1.67" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
        <span style={{ color: "#667085" }}>{t('prev')}</span>
      </Flex>
    </Button>
  }
  const arrowRight = () => {
    return <Button type="default" style={{ height: "36px" }}>
      <Flex gap={5} style={{
        placeItems: 'center'
      }}>
        <span style={{ color: "#667085" }}>{t('next')}</span>
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4.16666 9.99996H15.8333M15.8333 9.99996L9.99999 4.16663M15.8333 9.99996L9.99999 15.8333" stroke="#667085" stroke-width="1.67" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </Flex>
    </Button>
  }

  return (
    <MainLayout>
      {openListEmployee && (
        <Modal title={t("response_company.label.admin_list")}
          open={openListEmployee}
          onCancel={() => setOpenListEmployee(false)}
          footer={false}
          width="510px"
          maskClosable={false}
        >
          <Card size="small" style={{ border: "1px solid #000" }}>
            {selectedAdminList?.map((employee, index) => (
              <div key={index}>
                {i18n.language == "en" ? employee?.fullnameEn : employee?.fullname}
              </div>
            ))}
          </Card>
        </Modal>
      )}
      <Space size={24} direction="vertical" style={{ width: "100%" }}>
        <Flex vertical>
          <Breadcrumb items={[
            { title: t("home.header"), href: "" },
            { title: t("response_company.header") },
          ]} />
          <h2>{t("response_company.header")}</h2>
          <span style={{ color: "#667085" }}>{t("response_company.label.detail")}</span>
        </Flex>

        <Flex gap={8} justify="end">
          <Button
            type="default"
            onClick={() => setUseFilter(!useFilter)}
            style={{ padding: "8px 16px", height: "40px", borderRadius: "8px" }}
          >
            <Flex align="center" justify="center" gap={8}>
              <FilterIcon />
              <span style={{ color: "#667085" }}>{t('common.filter')}</span>
            </Flex>
          </Button>

          <Button
            type="primary"
            style={{ height: "40px", borderRadius: "8px", display: "flex", alignItems: "center", backgroundColor: "var(--button-color)" }}
            icon={<CreateIcon style={{ fontSize: 16 }} />}
            onClick={() => {
              navigate("/admin/create_company");
            }}
          >
            {t("response_company.label.add_company")}
          </Button>
        </Flex>

        {useFilter &&
          <Card style={{ border: "solid 1px #EAECF0" }}>
            <AdminCompanyFilter
              userAdminListOptions={userAdminListOptions}
              handleSearch={handleSearch} />
          </Card>
        }

        <ConfigProvider
          theme={{
            components: {
              Card: {
                paddingLG: "16px 8px"
              },
            },
          }}
        >
          <Card>
            <Row gutter={[16, 16]} style={{ marginLeft: "0px" }}>
              {companyList?.map((company, index) => (
                <Col span={8} key={index}>
                  <Card
                    style={{
                      border: "1px solid #D9D9D9",
                      borderRadius: "10px",
                      width: "100%",
                      height: "100%",
                      padding: "0px 12px",
                      position: "relative"
                    }}
                    onClick={() => handleCardClick(company.id)}
                    hoverable
                  >
                    <div style={{ position: "absolute", justifySelf: "flex-end" }}>
                      <StatusTag value={company?.statusFlag} />
                    </div>

                    <Flex vertical gap="10px" style={{ alignItems: "center" }}>
                      <Avatar
                        size={{ xs: 24, sm: 32, md: 40, lg: 64, xl: 80, xxl: 100 }}
                        src={company.logo ? "data:image/png;base64," + company?.logo : <UserOutlined />}
                        alt={company.companyName}
                        style={{ border: "1px solid #D9D9D9", backgroundColor: "#D9D9D9" }}
                      />

                      <Flex vertical style={{ alignSelf: "center", width: "100%" }}>
                        <h2 style={{ color: "#42526D", textAlign: "center" }}>
                          {i18n.language == "en" ? company.companyNameEn : company.companyName}
                        </h2>

                        <Row gutter={[8, 0]}>
                          <Col span={10} style={{ textAlign: "right" }}>
                            <span style={{ color: "#42526D" }} >{`${t("response_company.label.tax_id")} : `}</span>
                          </Col>
                          <Col span={14} style={{ wordBreak: "break-word" }}>
                            <span style={{ color: "#42526D" }} > {company?.taxId ? company?.taxId : "-"} </span>
                          </Col>
                        </Row>

                        <Row gutter={[8, 0]}>
                          <Col span={10} style={{ textAlign: "right" }}>
                            <span style={{ color: "#42526D" }}>
                              {`${t("response_company.label.careTaker")} :`}
                            </span>
                          </Col>
                          <Col span={14} style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                            <Text
                              style={{
                                color: "#42526D",
                                flexShrink: 1,
                                minWidth: 0
                              }}
                              ellipsis={{ tooltip: false }}
                            >
                              <span>
                                {company?.adminList?.length >= 1
                                  ? company?.adminList?.map(admin => admin.fullname)?.slice(0, 2).join(", ")
                                  : "-"}
                              </span>
                            </Text>

                            {company?.adminList?.length > 2 ? (
                              // eslint-disable-next-line jsx-a11y/anchor-is-valid
                              <a
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setSelectedAdminList(company?.adminList || []);
                                  setOpenListEmployee(true);
                                  // setListEmployees(workflow?.listEmployees);
                                }}
                                style={{
                                  display: "inline-block",
                                  borderRadius: "50%",
                                  padding: "4px",
                                  fontSize: "0.7vw",
                                  color: "#fff",
                                  background: "var(--button-color)",
                                  textDecoration: "none",
                                  fontWeight: "bold",
                                  border: "1px solid var(--button-color)",
                                  cursor: "pointer",
                                  flexShrink: 0
                                }}

                              >
                                {`+ ${company?.adminList?.length - 2}`}
                              </a>
                            ) : ""}
                          </Col>
                        </Row>

                        <Row gutter={[8, 0]}>
                          <Col span={10} style={{ textAlign: "right" }}>
                            <span style={{ color: "#42526D" }} >{`${t("response_company.label.start_date")} :`}</span>
                          </Col>
                          <Col span={14}>
                            <span style={{ color: "#42526D" }} > {company?.startDateInFlowHr ? i18n.language == "en" ? dayjs(company?.startDateInFlowHr).format("DD/MM/YYYY") : dayjs(company?.startDateInFlowHr).format("DD/MM/BBBB") : "-"} </span>
                          </Col>
                        </Row>

                        <Row gutter={[8, 0]}>
                          <Col span={10} style={{ textAlign: "right" }}>
                            <span style={{ color: "#42526D" }} >{`${t("response_company.label.number-of-employees")} :`}</span>
                          </Col>
                          <Col span={14}>
                            <span style={{ color: "#42526D" }} > {`${(company.countEmployee || 0).toLocaleString()} ${t("expense.expense-detail.person")}`} </span>
                          </Col>
                        </Row>

                      </Flex>
                    </Flex>
                  </Card>
                </Col>
              ))}
            </Row>
            <Pagination
              itemRender={(e, v, elements) => {
                if (v == 'prev' || v == 'next')
                  return v == 'prev' ? arrowLeft() : arrowRight()
                else return elements
              }}
              className={styles.pagination}
              current={pagination?.current || 1}
              pageSize={pagination?.size || 9}
              total={pagination?.total || 0}
              onChange={(page, pageSize) => {
                getAdminComapnyPagination({ page: page - 1, size: pageSize });

                window.scrollTo({
                  top: 0,
                  behavior: "smooth"
                });
              }}
            />
          </Card>
        </ConfigProvider>
      </Space>
    </MainLayout >
  );
};

export default AdminCompany;
